import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent} from './components/dashboard/dashboard.component';
import { CursosDisponibleComponent} from './components/cursos-disponible/cursos-disponible.component';
import { CursosInscritoComponent} from './components/cursos-inscrito/cursos-inscrito.component';
import { CapacitacionesUserComponent} from './components/capacitaciones-user/capacitaciones-user.component';
import { LoginComponent } from './components/login/login.component';
import { InicioComponent } from './components/inicio/inicio.component';
import { AppComponent } from './app.component';
import { AuthGuard } from './_helpers';
import { CursoInscritoDetalleComponent } from './components/curso-inscrito-detalle/curso-inscrito-detalle.component';
import { VisorPdfComponent } from './components/cursos-inscrito/visor-pdf/visor-pdf.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { UsuarioInfoComponent } from './components/usuario-info/usuario-info.component';


// import {AppComponent} from './app.component';
const routes: Routes = [

  {path: "", redirectTo: "Dashboard", pathMatch: "full"},
  {path: "login", component: LoginComponent, data: {title: "Login Page"}},
  {
		path: "reset-password",
		component: ResetPasswordComponent,
		data: {title: "Olvido su contraseña"}
	},
	// {
	// 	path: "reset-password",
	// 	component: ResetPasswordComponent,
	// 	data: {title: "Olvido su contraseña"}
	// },
	// {path: "404", component: P404Component, data: {title: "Error 404"}},
	// {path: "500", component: P500Component, data: {title: "Error 500"}},
  // {path: "incidentes", component: IncidentesComponent, data: {title: "Error 500"}},

  // {path: "Dashboard", component: DashboardComponent, data: {title: "Dashboard"}},
  // {path: "CursosDisponibles", component: CursosDisponibleComponent, data: {title: "Cursos Disponibles"}},
  // {path: "CursosInscrito", component: CursosInscritoComponent, data: {title: "Cursos Inscritos"}},
  // {path: "Capacitaciones", component: CapacitacionesUserComponent, data: {title: "Capacitaciones"}}

	{
		path: "",
		component: InicioComponent,
		data: {title: "Home"},
		canActivate: [AuthGuard],
		children: [
      {path: "Dashboard", component: DashboardComponent, data: {title: "Dashboard"}},
      {path: "CursosDisponibles", component: CursosDisponibleComponent, data: {title: "Cursos Disponibles"}},
      {path: "Capacitaciones", component: CapacitacionesUserComponent, data: {title: "Capacitaciones"}},
      {path: "CursosInscrito", component: CursosInscritoComponent, data: {title: "Cursos Inscritos"}},
      
      {path: "CursoDetalle", component: CursoInscritoDetalleComponent, data: {title: "Curso Detalle"}},
      {path: "VerDocumento", component: VisorPdfComponent, data: {title: "Ver Documento"}},
      {path: "InformacionUsuario", component: UsuarioInfoComponent, data: {title: "Datos del Usuario "}}


    ]
    }


];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}





